import React from 'react';
import PropTypes from 'prop-types';
import {
	BanksyImage,
	Box,
	LinkIcon,
	Flex,
	PrimaryButton,
	SecondaryButton,
	SmartLink,
	useSnackbarContext,
	ChoiceGroup,
	ChoicePad,
} from '@stashinvest/ui';
import { BanjoString } from '@stashinvest/react-banjo';
import { Link } from 'react-router-dom';
import { Text } from '@stashinvest/ui/dist/es/2';

const PendingState = ({ successPath }) => {
	return (
		<div>
			<Text.Body16 mb="m" align="center">
				You&apos;re ready to make your first investment.
			</Text.Body16>
			<Box mt="s24" mb="s36" pl="s56" pr="s56">
				<PrimaryButton as={SmartLink} to="/browse-collection/companies">
					Browse investments
				</PrimaryButton>
				<br />
				<SecondaryButton as={SmartLink} to={successPath}>
					Maybe later
				</SecondaryButton>
				<Text.Body12 mt="s24">
					<BanjoString stringId="information/disclose/logoOrIPUse" />
				</Text.Body12>
			</Box>
		</div>
	);
};

const SuccessState = () => {
	return (
		<div>
			<Box mt="s8" mb="s36" px="s48">
				<ChoiceGroup cols={1}>
					<ChoicePad
						as={Link}
						to="/browse-collection/companies"
						style={{ textDecoration: 'none' }}
						label={
							<Flex
								alignSelf="flex-start"
								flexDirection="column"
								style={{ textAlign: 'left' }}
							>
								<Text.Label16 fontWeight="bold">Make an investment</Text.Label16>
								<Text.Body14>Browse stocks and ETFs.</Text.Body14>
							</Flex>
						}
					/>
					<ChoicePad
						as={Link}
						to="/transfer/sources"
						style={{ textDecoration: 'none' }}
						label={
							<Flex
								alignSelf="flex-start"
								flexDirection="column"
								style={{ textAlign: 'left' }}
							>
								<Text.Label16 fontWeight="bold">Add cash</Text.Label16>
								<Text.Body14>Make a transfer to Stash.</Text.Body14>
							</Flex>
						}
					/>
				</ChoiceGroup>
				<Text.Body12 mt="s24">
					<BanjoString stringId="information/disclose/logoOrIPUse" />
				</Text.Body12>
			</Box>
		</div>
	);
};

const LinkCrossSell = ({ accountName, isLinked, successPath, maskedNumber }) => {
	const { setSnackbar } = useSnackbarContext();
	React.useEffect(() => {
		setSnackbar({
			icon: <LinkIcon />,
			title: isLinked ? 'Bank account successfully linked' : 'Bank link pending',
			body: isLinked
				? `${accountName} ${maskedNumber} is now linked to Stash.`
				: "We'll notify you when your account is linked.",
			backgroundColor: isLinked ? 'bgActionSecondary' : 'bgWarningSecondary',
		});
	}, []);

	return (
		<>
			<Flex justifyContent="center" alignItems="center" flexDirection="column">
				<BanksyImage
					maxWidth="300px"
					src="/images/illustrations/scene/investmentCrossSell/investmentCrossSell.png"
				/>
				<Text.Title28 mt="s20" mb="s12" align="center" fontWeight="bold">
					{isLinked ? 'Ready to start investing?' : 'Start growing your Stash'}
				</Text.Title28>
				{isLinked ? <SuccessState /> : <PendingState successPath={successPath} />}
			</Flex>
		</>
	);
};

LinkCrossSell.defaultProps = {
	successPath: '/',
};

LinkCrossSell.propTypes = {
	successPath: PropTypes.string,
};

export default LinkCrossSell;
